import { Div, P } from '@kizi/core-components';
import React from 'react';

const defaultDropDownValues = [
  { label: 'Maak een keuze', value: 0 },
  { label: 'Minimaal € 1.250', value: 1 },
  { label: 'Minimaal € 2.500', value: 2 },
  { label: 'Minimaal € 5.000', value: 3 },
  { label: 'Minimaal € 7.500', value: 4 },
  { label: 'Minimaal € 10.000', value: 5 },
  { label: 'Minimaal € 15.000', value: 6 },
  { label: 'Minimaal € 20.000', value: 7 },
];

const additionalCoverages = [
  {
    label: 'Aansprakelijkheid',
    id: 'additionalCoverage',
    value: [
      {
        label: '€ 1.250.000,-',
        value: '0',
      },
      {
        label: '€ 2.500.000,-',
        value: '1',
      },
    ],
  },
  {
    label: 'Allrisk',
    id: 'all_risk',
  },
  {
    label: 'Buitenhuisdekking',
    id: 'outsideCoverage',
    value: [
      {
        label: 'Maak een keuze',
        value: '0',
      },
      {
        label: 'Minimaal €2.500,-',
        value: '1',
      },
      {
        label: 'Minimaal €5.000,-',
        value: '2',
      },
      {
        label: 'Minimaal €7.500,-',
        value: '3',
      },
      {
        label: 'Minimaal €10.000,-',
        value: '4',
      },
    ],
  },
  {
    label: 'Glas',
    id: 'glass',
  },
  {
    label: 'Audio / tv',
    value: defaultDropDownValues,
    id: 'audio_tv',
  },
  {
    label: 'Computers',
    value: defaultDropDownValues,
    id: 'computers',
  },
  {
    label: 'Sieraden',
    value: defaultDropDownValues,
    id: 'jewelry',
  },
  {
    label: 'Kunst',
    value: defaultDropDownValues,
    id: 'art',
  },
  {
    label: 'Instrumenten',
    value: defaultDropDownValues,
    id: 'instruments',
  },
  {
    label: 'Antiek',
    value: defaultDropDownValues,
    id: 'antique',
  },
  {
    label: 'Verzameling',
    value: defaultDropDownValues,
    id: 'collection',
  },
  {
    label: 'Huurdersbelang',
    value: [
      { label: 'Maak een keuze', value: '0' },
      { label: 'Minimaal €2.500,-', value: '1' },
      { label: 'Minimaal €5.000,-', value: '2' },
      { label: 'Minimaal €7.500,-', value: '3' },
      { label: 'Minimaal €10.000,-', value: '4' },
    ],
    id: 'tenantInterest',
  },
];

export const parseAdditionalCoverageData = (filters) => {
  const result: JSX.Element[] = [];
  additionalCoverages.forEach((coverage) => {
    const filterValue = filters[coverage.id];
    if (Array.isArray(filterValue) && Number(filterValue[0]) > -1) {
      const priceLabel = coverage?.value
        ? (coverage.value as any[]).find(
            (item) => Number(item.value) === Number(filterValue[0])
          )
        : null;
      result.push(
        <Div display="flex" justifyContent="space-between" mb={1}>
          <P>{coverage.label}</P>
          <P>{priceLabel && priceLabel.label}</P>
        </Div>
      );
    }
  });

  return result;
};
